import { isAfter, isBefore } from 'date-fns';

import { Hedge, HedgeListItem, Status } from 'shared/types';

export const resolveHedgeStatus = (hedge: Hedge | HedgeListItem): Status =>
  isAfter(Date.now(), new Date(hedge.placedAt)) && isBefore(Date.now(), new Date(hedge.expiresAt))
    ? Status.ACTIVE
    : Status.INACTIVE;
